function addXMLRequestCallback(callback){
    var oldSend, i;
    if( XMLHttpRequest.callbacks ) {
        XMLHttpRequest.callbacks.push( callback );
    } else {
        XMLHttpRequest.callbacks = [callback];
        oldSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function(){
            for( i = 0; i < XMLHttpRequest.callbacks.length; i++ ) {
                XMLHttpRequest.callbacks[i]( this );
            }
            oldSend.apply(this, arguments);
        }
    }
}
addXMLRequestCallback( function( xhr ) {
  $('address').each(function(){
    var txt = $(this).html();
    $(this).html(
      txt.replace(/Tōkyō/g,'東京都')
         .replace(/Aichi/g,'愛知県')
         .replace(/Akita/g,'秋田県')
         .replace(/Aomori/g,'青森県')
         .replace(/Chiba/g,'千葉県')
         .replace(/Ehime/g,'愛媛県')
         .replace(/Fukui/g,'福井県')
         .replace(/Fukuoka/g,'福岡県')
         .replace(/Fukushima/g,'福島県')
         .replace(/Gifu/g,'岐阜県')
         .replace(/Gunma/g,'群馬県')
         .replace(/Hiroshima/g,'広島県')
         .replace(/Hokkaidō/g,'北海道')
         .replace(/Hyōgo/g,'兵庫県')
         .replace(/Ibaraki/g,'茨城県')
         .replace(/Ishikawa/g,'石川県')
         .replace(/Iwate/g,'岩手県')
         .replace(/Kagawa/g,'香川県')
         .replace(/Yamanashi/g,'山梨県')
         .replace(/Yamaguchi/g,'山口県')
         .replace(/Kōchi/g,'高知県')
         .replace(/Kumamoto/g,'熊本県')
         .replace(/Kyōto/g,'京都府')
         .replace(/Mie/g,'三重県')
         .replace(/Yamagata/g,'山形県')
         .replace(/Miyazaki/g,'宮崎県')
         .replace(/Nagano/g,'長野県')
         .replace(/Nagasaki/g,'長崎県')
         .replace(/Nara/g,'奈良県')
         .replace(/Niigata/g,'新潟県')
         .replace(/Ōita/g,'大分県')
         .replace(/Okayama/g,'岡山県')
         .replace(/Okinawa/g,'沖縄県')
         .replace(/Ōsaka/g,'大阪府')
         .replace(/Saga/g,'佐賀県')
         .replace(/Saitama/g,'埼玉県')
         .replace(/Shiga/g,'滋賀県')
         .replace(/Shimane/g,'島根県')
         .replace(/Shizuoka/g,'静岡県')
         .replace(/Tochigi/g,'栃木県')
         .replace(/Tokushima/g,'徳島県')
         .replace(/Tottori/g,'鳥取県')
         .replace(/Toyama/g,'富山県')
         .replace(/Miyagi/g,'宮城県')
         .replace(/Wakayama/g,'和歌山県')
         .replace(/Kanagawa/g,'神奈川県')
         .replace(/Kagoshima/g,'鹿児島県')
    );
  });
});